import { useMutation } from 'react-query';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { postV2ApiCompanyIdTravelPropertiesSearch } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdTravelPropertiesSearchRequest } from 'src/client/spendesk-api-types';
import { formatDateToApiString } from 'src/core/common/utils/formatDateToApiString';

const RADIUS_IN_METERS = 5000;
const ROOMS_COUNT = 1;
const ADULTS_COUNT = 1;

export const usePropertiesSearchMutation = () => {
  const companyId = useCompanyId();
  return useMutation(
    async (
      payload: PostV2ApiCompanyIdTravelPropertiesSearchRequest['body'],
    ) => {
      return postV2ApiCompanyIdTravelPropertiesSearch({
        path: { companyId },
        body: payload,
      });
    },
  );
};

export const transformToPayload = (
  location: { latitude: number; longitude: number; name: string },
  checkin: Date,
  checkout: Date,
): PostV2ApiCompanyIdTravelPropertiesSearchRequest['body'] => {
  return {
    location: {
      coordinates: {
        latitude: location.latitude,
        longitude: location.longitude,
      },
      address: {
        full: location.name,
      },
    },
    radius: RADIUS_IN_METERS,
    checkInDate: formatDateToApiString(checkin),
    checkOutDate: formatDateToApiString(checkout),
    roomsCount: ROOMS_COUNT,
    adultsCount: ADULTS_COUNT,
  };
};
